import {useMutation, useQuery} from "@apollo/client";

import {
  AccountUserFormDependencyResult,
  GQL_ACCOUNTUSER_FORM_DEPENDENCY_QUERY,
  GQL_ACCOUNTUSER_UPDATE,
  GQL_ACCOUNTUSERS_QUERY,
  GQL_USER_CONTEXT,
  UpdateAccountUserResult,
} from "@/lib/queries/accounts.ts";
import {AccountUserBase} from "@/lib/types/accounts.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {UserFormValues} from "@/pages/accounts/edit/EditUserFormBasic.tsx";
import {EditUserModal} from "@/pages/accounts/edit/EditUserModal.tsx";

interface EditUserActionProps {
  formId: string;
  show: boolean;
  setShow: (show: boolean) => void;
  user?: AccountUserBase;
}

export const EditUserModalAction = ({formId, user, show, setShow}: EditUserActionProps) => {
  const [updateAccountUser, {data}] = useMutation<UpdateAccountUserResult>(GQL_ACCOUNTUSER_UPDATE, {
    refetchQueries: [GQL_ACCOUNTUSERS_QUERY, GQL_USER_CONTEXT],
    context: {
      noToast: true,
    },
  });
  const {data: dependencyData} = useQuery<AccountUserFormDependencyResult>(GQL_ACCOUNTUSER_FORM_DEPENDENCY_QUERY);

  const handleSubmit = async (data: UserFormValues) => {
    const resp = await updateAccountUser({
      variables: {data},
    });
    if (resp.data?.response?.status === ResponseStatus.ERROR) {
      return;
    }
    setShow(false);
  };

  if (!dependencyData) return null;

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message : undefined;

  return (
    <EditUserModal
      user={user}
      accountAccounts={dependencyData.accountAccounts}
      availableContactGroups={dependencyData.availableContactGroups}
      title={user ? "Edit Account User" : "Add Account User"}
      formId={formId}
      show={show}
      hide={() => {
        setShow(false);
      }}
      onSubmit={handleSubmit}
      serverErrors={serverErrors}
    />
  );
};
